const marquee = () => {
    const marquees = document.querySelectorAll('[data-marquee]');
    if (!marquees.length) return;

    marquees.forEach(element => {
        const track = element.querySelector('[data-marquee-track]');
        if (track) {
            const clonedTrack = track.cloneNode(true);
            element.appendChild(clonedTrack);
        }
    });
};

// Run when DOM is fully loaded
document.addEventListener('DOMContentLoaded', marquee);

export default marquee;